import { render, staticRenderFns } from "./Evolution.vue?vue&type=template&id=fbd4bb52&"
import script from "./Evolution.vue?vue&type=script&lang=js&"
export * from "./Evolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports